import { gql, useMutation } from '@apollo/client';
import { GqlError, formatErrors } from '../utils/errors';
import { sanitizeUrl } from '../utils/transformers';

const CREATE_VIRTUAL_EVENT_URL_MUTATION = gql`
  mutation createVirtualEventUrlMutation(
    $memberEventId: Int!
    $url: String,
  ) {
    createVirtualEventUrl(input: {
      virtualEventUrl: {
        url: $url,
        memberEventId: $memberEventId,
      }
    }) {
      virtualEventUrl {
        id
        url
        memberEventId
      }
    }
  }
`;

const useCreateVirtualEventUrl = (onCompleted) => {
  const [createVirtualEventUrlMutation, { loading, data, error }] = useMutation(
    CREATE_VIRTUAL_EVENT_URL_MUTATION,
    { onCompleted },
  );

  const createVirtualEventUrl = async ({ url, memberEventId }) => {
    try {
      const response = await createVirtualEventUrlMutation({
        variables: {
          url: url ? sanitizeUrl(url.trim()) : null,
          memberEventId,
        },
      });
      return response.data.createVirtualEventUrl;
    } catch (e) {
      const formattedErrors = formatErrors(e);
      throw new GqlError({
        name: 'Virtual Event URL Error',
        errors: formattedErrors,
      });
    }
  };

  return [
    createVirtualEventUrl,
    {
      loading,
      data,
      error: error ? formatErrors(error) : null,
    },
  ];
};

export default useCreateVirtualEventUrl;
